export const summaryRows: Array<[string, string]> = [
  ['Volume 1 — Renewable Energy Fundamentals', 'Global energy matrices, sustainability and the energy transition'],
  ['Volume 2 — Solar Energy', 'Panels, inverters, batteries and basic system sizing'],
  ['Volume 3 — Wind Energy', 'Turbines, power curves and wind farms'],
  ['Volume 4 — Hydropower & Marine Energy', 'Flow, head, turbines and micro-hydropower'],
  ['Volume 5 — Biomass, Bioenergy & Biofuels', 'Digesters, biogas, bioethanol and biodiesel'],
  ['Volume 6 — Geothermal & Emerging Renewables', 'Geothermal, marine energy and green hydrogen'],
  ['Volume 7 — Energy Storage & Smart Grids', 'Batteries, BESS, microgrids and autonomy calculations'],
  ['Volume 8 — System Design & Sizing', '20 worked exercises and 8 complete design case studies'],
  ['Volume 9 — Teaching Renewable Energy', 'Teaching sequences, rubrics and 10 capstone projects'],
  ['Bonus 1 — 150 Classroom Activities', 'Organized by difficulty, for classroom and lab'],
  ['Bonus 2 — 100 Solved Problems', 'Power, generation, efficiency, autonomy and sizing'],
  ['Bonus 3 — Complete Assessment Suite', 'Diagnostics, integrated tests, rubrics and criteria'],
  ['Bonus 4 — 50 Projects & STEM Challenges', 'With objectives, materials, stages and evaluation criteria'],
  ['Bonus 5 — Visual Component Guide', 'Diagrams and comparison tables of technologies and equipment'],
  ['7-day money-back guarantee', '100% refund with no forms and no complications'],
  ['Instant access', 'Delivered by email, with no waiting and no paperwork'],
];
